import { Component, OnInit, HostListener } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-header-v4',
  templateUrl: './header-v4.component.html',
  styleUrls: ['./header-v4.component.scss']
})
export class HeaderV4Component implements OnInit {

  constructor(
    public utils:UtilsService
  ) { }

  ngOnInit() {
    
  }

}
